export interface Product {
  id: number;
  name: string;
  description: string;
  image: string;
  oldPrice: number | null;
  discount: number | null;
  price: number;
  brandId: number | null;
  slug: string;
  isActive: boolean;
  isNew: boolean;
  createdAt: string;
  categoryIds: number[];
  thumbnail: string | null;
  views?: number;
  ordersCount?: number;
}

export interface ProductInput {
  name: string;
  description: string;
  image: string;
  thumbnail?: string | null;
  price: number;
  oldPrice?: number | null;
  brandId?: number | null;
  isActive?: boolean;
  isNew?: boolean;
  categoryIds?: number[];
}

/** Partial on purpose: the omitted price is taken from the DB, so two quick edits don't race. */
export interface ProductPriceInput {
  price?: number;
  oldPrice?: number | null;
}

/** Old price is optional (empty or 0 means no discount), but when set it must exceed the price. */
export const isValidOldPrice = (price: number, oldPrice: number | null | undefined): boolean =>
  !oldPrice || oldPrice > price;

export interface PaginatedProducts {
  hits: Product[];
  total: number;
}
